module.exports = __webpack_public_path__ + "static/media/solar-logo.8f27c7e3.svg";